export default __webpack_public_path__ + "static/media/banner.5f8e6524.png";